<!-- 客人时段 -->
<template>
    <div id="home">
    	<van-nav-bar
		  	:title="$t('CustomerTime.title')"
			left-arrow
			fixed
		  	@click-left="$router.go(-1)">
		</van-nav-bar>
		<div class="contentWrapper">
			<van-cell-group>
				<span class="text">{{$t('CustomerTime.text1')}}</span>
				<van-field
					class="inputAr"
					readonly  	
					right-icon="arrow" 	  	
					@click="showStartTimePicker = true" 	
					:value='customer.startTime'
				/> 
				<!-- 弹框 -->
				<van-popup v-model="showStartTimePicker" position="bottom">
					<van-datetime-picker
						v-model="currentDate"
						type="date"
						:max-date="maxDate"
						:confirm-button-text="$t('vantText.confirm')"
						:cancel-button-text="$t('vantText.cancel')"
						@cancel="showStartTimePicker = false"
						@change="changeStartTime()"
						@confirm="onStartChangeConfirm"
					/>
				</van-popup>
				<span class="text">{{$t('CustomerTime.text')}}</span>
				<van-field
					class="inputAr"
					readonly
					right-icon="arrow" 		
					@click="showEndTimePicker = true"
					:value='customer.endTime'
				/>  
				<!-- 弹框 -->
				<van-popup v-model="showEndTimePicker" position="bottom">
					<van-datetime-picker
						v-model="currentEndDate"
						type="date"
						:min-date="minDate"
						:confirm-button-text="$t('vantText.confirm')"
						:cancel-button-text="$t('vantText.cancel')"
						@cancel="showEndTimePicker = false"
						@change="changeEndTime()"
						@confirm="onChangeConfirm"
					/>
				</van-popup>
			</van-cell-group>
			<div class="divideLine"></div>
			<!-- 折线图 -->
			<div id="chart" style="width: 100%;height: 200px;"></div>
			<div class="divideLine"></div>
			<van-cell :title="$t('CustomerTime.time')" :value="$t('CustomerTime.peoopleNum')" class='title'></van-cell>
			<template v-for='(item,index) in customerDate'>
				<van-cell :title=item.time :value="item.number+$t('CustomerTime.people')"></van-cell>
			</template>
		</div>
    </div>
</template>
<script>
  	export default {
  		data(){
  			return{
  				customer:{
  					startTime:this.formatDateYMD1(new Date()),
  					endTime:this.formatDateYMD(new Date())
  				},
  				maxDate:new Date(),
  				minDate:new Date(),
  				showStartTimePicker:false,
  				showEndTimePicker:false,
  				currentDate:new Date(),
  				currentEndDate:new Date(),
  				options:{
  					legend:{
  						name:this.$t('CustomerTime.title')
  					},
				    color: ['red'],
					tooltip: {},
					toolbox: {
                        feature: {
                            saveAsImage: {
                            }
                        }
                    },
                    grid: {
                        left: '0.5%',
                        // right: '3%',
                        bottom: '10%',
                        containLabel: true
                    },
				    xAxis: {
				    	name:this.$t('CustomerTime.t'),
				        data: [],  //横坐标
				    	axisTick: {
			                alignWithLabel: true,
			            },
			            boundaryGap: false,
			            axisLabel:{
			                interval:0
			            }
				    },
				    yAxis: {
				    	name:this.$t('CustomerTime.num'),
				    },
				    series: [{
				        name: this.$t('CustomerTime.title'),
				        type: 'line',
				        label: {
			                normal: {
			                    show: true,
			                    position: 'top'
			                }
	            		},
				        data: [],  //纵坐标
				    }]
	      		},
  				customerChart:'',
  				customerDate:[],
  			}
  		},
  		mounted:function(){
  			// this.customer.startTime=this.formatDateYMD1(new Date());
  			// this.customer.endTime=this.formatDateYMD(new Date());
	    	this.customerChart=this.$echarts.init(document.getElementById("chart"));
	    	this.getCustomerDate();
	    	console.log(this.currentDate)
	    },
  		methods:{
	    	getCustomerDate(){
				this.$axios({
	                method: 'PATCH',
	                headers: {
	                    "Authorization": 'Bearer '+sessionStorage.token,
	                },
	                url: this.$build+'/api/store/'+sessionStorage.actShopId+'/guestMoment',
	                data:{
	                	startday:this.customer.startTime,
	                	endday:this.customer.endTime,
	                }
	            }).then(res => {
	            	if(res.data.status==200){
	                	this.customerDate=res.data.data;
	                	this.options.xAxis.data=res.data.time;
	                	this.options.series[0].data=res.data.number;
	    				this.customerChartInit();
	            	}else{
	            		for (var item in res.data.error) {
	            			this.$toast({
			            		type:'fail',
			            		message:res.data.error[item],
			            	});
	            		}
	            	}
	            }).catch(err => {
	            	
	            });
	    	},
	    	customerChartInit(){
	    		this.customerChart.setOption(this.options);
	    	},
	    	onChangeConfirm(){
				this.customer.endTime=this.formatDateYMD(this.currentEndDate);
	    		this.getCustomerDate();
	    		this.showEndTimePicker = false;
	    		console.log(this.customer.endTime);
	    		console.log(this.customer.startTime);
	    	},
	    	onStartChangeConfirm(){
	    		this.customer.startTime=this.formatDateYMD(this.currentDate);
	    		this.showStartTimePicker=false;
	    		this.getCustomerDate();
	    	},
	    	//开始时间显示前一个月
	    	formatDateYMD1(value){
			    if (!value){ 
			        return '';
			    }else{
			        var date = new Date(value);
			        var Y = date.getFullYear();
			        var M = (date.getMonth()+1);
			        var D = date.getDate();

			        //获取前一个月的日期
			        var Y2=Y;
			        var M2=parseInt(M) - 1;
			        //如果月为0则显示去年最后一个月12月
			        if(M2==0){
			        	Y2 = parseInt(Y2) - 1;
        				M2 = 12;
			        }
			        var D2=D;
			        var DS2=new Date(Y2, M2, 0); 
			        DS2=DS2.getDate(); 
			        if(D2>DS2){
			        	D2=DS2
			        }
			        if(M2<10){
			        	M2='0'+M2;
			        }
			        var t2=Y2 + '/' + M2 + '/' + D2;
			        return t2;
			    }
			},
			formatDateYMD(value){
			    if (!value){ 
			        return '';
			    }else{
			        var date = new Date(value);
			        var Y = date.getFullYear()+'/';
			        var M = (date.getMonth()+1)+ '/';
			        var D = date.getDate();
			        return Y+M+D;
			    }
			},
			changeStartTime(){
				this.customer.startTime=this.formatDateYMD(this.currentDate);
				this.minDate=this.currentDate;
			},
			changeEndTime(){
				this.customer.endTime=this.formatDateYMD(this.currentEndDate);
				this.maxDate=this.currentEndDate;
			},
	  	}
  		
  	}
</script>
<style scoped>
	/deep/ .van-nav-bar .van-icon{
		font-size: 24px;
		color: #fff;
	}
	/deep/ .van-cell{
		line-height: 24px;
	}
	/deep/ .van-tabs__line{
		background-color: #fd3f3f;
	}
	/deep/ .van-picker__cancel,/deep/ .van-picker__confirm{
		color: #2f75f7
	}
	.contentWrapper{
		padding-top: 0px;
	}
	/*分割线*/
	.divideLine{
		height: 5px;
		background: #F3F5F7;
	}
	.van-row{
		text-align: center;
	}
	.van-cell-group{
		padding: 15px;
		display: flex;
		justify-content: space-between;
	}
	.inputAr{
		width: 40%;
		line-height: 15px;
		border: 2px solid #000;
		border-radius: 50px;
		font-size: 14px;
	}
	/* 至 */
	.text{
		line-height: 35px
	}
	#chart{
		background: #fff;
	}
	.title{
		font-size: 14px;
		color: #444;
	}
</style>


// WEBPACK FOOTER //
// src/Report/CustomerTime.vue